/* eslint-disable import/no-cycle */
import api from '@/plugins/axios';

const state = {
  classifications: []
};

const getters = {
  classifications: (state) => state.classifications
};

const mutations = {
  SET_CLIENT_CLASSIFICATIONS(state, classifications) {
    state.classifications = classifications;
  }
};

const actions = {
  getClientClassifications({ commit }) {
    api
      .get('/client/classifications', {
        params: {
          size: 999
        }
      })
      .then((response) => {
        commit('SET_CLIENT_CLASSIFICATIONS', response.data.rows);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
